var Ntss;
(function (Ntss) {
    Ntss.isDebugging = true, Ntss.displayExceptions = true, Ntss.displayLogging = true;
})(Ntss || (Ntss = {}));
